import {
  IAccTransactionExtendedData,
  TransactionStatus,
  isAccTransactionExtendedData,
} from '@principle-theorem/principle-core/interfaces';
import { toMoment } from '@principle-theorem/shared';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { GeneralProviderActionsService } from '../../general-provider-actions.service';
import {
  ITransactionAction,
  ITransactionActionsData,
} from '../../transaction-action';
import { TransactionHelpers } from '../../transaction-helpers';

export class ApproveAccTransaction
  implements ITransactionAction<IAccTransactionExtendedData>
{
  icon = 'done';
  label = 'Approve';
  tooltip = 'Confirm ACC payment received against your remittance advice';
  inProgress$ = new BehaviorSubject<boolean>(false);
  typeGuardFn = isAccTransactionExtendedData;

  constructor(private _actions: GeneralProviderActionsService) {}

  canDo$(
    data: ITransactionActionsData<IAccTransactionExtendedData>
  ): Observable<boolean> {
    return TransactionHelpers.lastTransaction$(
      data,
      isAccTransactionExtendedData
    ).pipe(
      map((transaction) => {
        if (!transaction) {
          return false;
        }
        return transaction.status === TransactionStatus.Pending;
      })
    );
  }

  async do(
    data: ITransactionActionsData<IAccTransactionExtendedData>
  ): Promise<void> {
    this.inProgress$.next(true);
    const extendedData = data.latestTransaction.extendedData;
    const paymentDate = extendedData?.paymentDate;

    const transaction =
      extendedData?.awardedAmount !== undefined
        ? { ...data.latestTransaction, amount: extendedData.awardedAmount }
        : data.latestTransaction;

    await this._actions.approve(
      data.invoice,
      transaction,
      'Approve ACC Claim',
      paymentDate ? toMoment(paymentDate) : undefined
    );
    this.inProgress$.next(false);
  }
}
